var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KSelect',{attrs:{"label":"Select options","options":_vm.options,"multiple":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }